import Vue from 'vue'
import Router from 'vue-router'
// 引入 PC/移动端页面
import PcIndex from '@/views/pc/index'
import NewsList from '@/views/pc/news/list'
import NewsDetail from '@/views/pc/news/detail'
import MobileIndex from '@/views/mobile/index'
import CourseInfo from '@/views/pc/course/info'
import CategoryList from '@/views/pc/course/categorylist'
import MyCenter from '@/views/pc/user/my.vue'
import Search from '@/views/pc/course/search'
import Pay from '@/views/pc/course/pay'
// 移动端页面
import MobileCourseInfo from '@/views/mobile/course/info'
import MobileCategoryList from '@/views/mobile/course/categorylist'
import MobileSearch from '@/views/mobile/course/search'
import MobilePay from '@/views/mobile/course/pay'
import MobileMyCenter from '@/views/mobile/mobile/user/my'
import MobileNewsList from '@/views/mobile/news/list'
import MobileNewsDetail from '@/views/mobile/news/detail'

Vue.use(Router)

// 提前定义设备判断函数，使用UA判断
const judgeDevice = () => {
    if (typeof window === 'undefined') return false
    const ua = navigator.userAgent.toLowerCase()
    
    // 排除PC端浏览器（即使UA包含mobile关键字）
    if (/(windows nt|macintosh|linux x86_64)/.test(ua) && !/(android|iphone|ipad|ipod)/.test(ua)) {
        return false
    }
    
    // 排除平板设备当作PC端
    if (/ipad/.test(ua) || (/android/.test(ua) && !/mobile/.test(ua))) {
        return false
    }
    
    // 检测真实移动设备
    return /android.*mobile|iphone|ipod|windows phone|blackberry|iemobile|opera mini|mobile safari/.test(ua)
}

// 根路由：初始根据设备渲染对应组件
const rootRoute = [
    {
        path: '/',
        name: 'Root',
        component: judgeDevice() ? MobileIndex : PcIndex,
        alias: '' // 匹配不带/的根路径
    },
    // 课程详情页动态路由（核心配置）
    {
        path: '/course/:id', // :id 是动态路由参数，对应跳转时的 ${id}
        name: 'CourseInfo',
        component: CourseInfo,
        props: true // 可选：开启props，方便组件接收路由参数
    },
    // 课程分类列表
    {
        path: '/category',
        name: 'CategoryListAll',
        component: CategoryList
    },
    {
        path: '/category/:id',
        name: 'CategoryList',
        component: CategoryList,
        props: true
    },
    // 个人中心
    {
        path: '/my', // :id 是动态路由参数，对应跳转时的 ${id}
        name: 'MyCenter',
        component: MyCenter
    },
    // 搜索页
    {
        path: '/search',
        name: 'Search',
        component: Search
    },
    // 支付页
    {
        path: '/pay',
        name: 'Pay',
        component: Pay
    },
    // 新闻列表
    {
        path: '/news',
        name: 'NewsList',
        component: NewsList
    },
    // 新闻详情
    {
        path: '/news/:id',
        name: 'NewsDetail',
        component: NewsDetail,
        props: true
    },
    // 移动端路由
    {
        path: '/mobile',
        name: 'MobileIndex',
        component: MobileIndex
    },
    {
        path: '/mobile/course/:id',
        name: 'MobileCourseInfo',
        component: MobileCourseInfo,
        props: true
    },
    {
        path: '/mobile/category',
        name: 'MobileCategoryListAll',
        component: MobileCategoryList
    },
    {
        path: '/mobile/category/:id',
        name: 'MobileCategoryList',
        component: MobileCategoryList,
        props: true
    },
    {
        path: '/mobile/search',
        name: 'MobileSearch',
        component: MobileSearch
    },
    {
        path: '/mobile/pay',
        name: 'MobilePay',
        component: MobilePay
    },
    {
        path: '/mobile/my',
        name: 'MobileMyCenter',
        component: MobileMyCenter
    },
    {
        path: '/mobile/news',
        name: 'MobileNewsList',
        component: MobileNewsList
    },
    {
        path: '/mobile/news/:id',
        name: 'MobileNewsDetail',
        component: MobileNewsDetail,
        props: true
    },
]

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    strict: false,
    routes: rootRoute
})

// 修复1：路由守卫仅做兜底，不触发跳转，避免循环/重复导航
router.beforeEach((to, from, next) => {
    // 仅当路径是根路径（带/或不带/）时，更新组件（无跳转，仅替换）
    if (to.path === '/' || to.path === '') {
        rootRoute.component = judgeDevice() ? MobileIndex : PcIndex
    }
    next() // 直接放行，无任何跳转操作
})

// 修复2：窗口大小变化时，仅更新组件，不触发路由跳转（核心解决重复导航）
if (typeof window !== 'undefined') {
    window.addEventListener('resize', () => {
        // 直接替换路由组件，不调用router.replace/router.push
        rootRoute.component = judgeDevice() ? MobileIndex : PcIndex
        // 手动触发Vue重新渲染（可选，确保组件实时更新）
        const vm = router.app // 获取Vue根实例
        if (vm) vm.$forceUpdate()
    })
}

// 可选：全局捕获重复导航错误，避免控制台报警
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err
    })
}

export default router